<template>
	<CardListSection
		:id="`c-frontpage-cards-${$vnode.key}`"
		v-bind="$props"
		:is-gray="false"
		show-link-at-bottom
		class="c-frontpage-cards"
		:class="'c-frontpage-cards--' + variant"
	/>
</template>

<script>
import CardListSection from '~/components/main/CardListSection';

export default {
	name: 'FrontpageCards',

	components: {
		CardListSection,
	},
	inheritAttrs: false,

	props: {
		title: {
			type: String,
			default: null,
		},
		teaser: {
			type: String,
			default: null,
		},

		items: {
			type: Array,
			default: () => [],
		},

		link: {
			type: Object,
			default: null,
		},
		variant: {
			type: String,
			default: 'default',
		},
	},
};
</script>

<style lang="postcss">
.c-frontpage-cards--teal .c-card-item {
	& figure + div * {
		@apply text-white !important;
	}
	& > * {
		@apply bg-theme;

		&:before {
			@apply bg-theme-40 bg-opacity-20;
		}
	}
}
.c-frontpage-cards--green .c-card-item {
	& figure + div * {
		@apply text-theme-text;
	}
	& > * {
		@apply bg-gray;

		&:before {
			@apply bg-theme-40 bg-opacity-20;
		}
	}
}
</style>
